import GrowBadge from './GrowBadge';

export default GrowBadge;